
import React, { createContext, useState, useContext } from "react";
import Cookies from 'js-cookie'; 

// Membuat konteks untuk job
const JobContext = createContext();

// Membuat provider untuk konteks job
export const JobProvider = ({ children }) => {
  const [jobList, setJobList] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null); 

  // Fungsi untuk mengupdate job list
  const fetchJobList = () => {
    const token = Cookies.get("token");
  
    // Jika token tidak ada, hentikan proses
    if (!token) {
      console.error("Token is missing");
      return;
    }
  
    fetch("https://final-project-api-alpha.vercel.app/api/jobs", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Mengirimkan token untuk otentikasi
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error fetching jobs: ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => {
        setJobList(data); 
      })
      .catch((error) => {
        console.error("Error fetching jobs:", error);
      });
  };
  

  // Fungsi untuk memilih job yang akan diedit
  const editJob = (jobId) => {
    const job = jobList.find((job) => job._id === jobId);
    setSelectedJob(job);
  };

// Fungsi untuk menghapus job
const deleteJob = (jobId) => {
    const token = Cookies.get("token"); 
  
    if (!token) {
      alert("Authorization required. Please login.");
      return; 
    }
  
    fetch(`https://final-project-api-alpha.vercel.app/api/jobs/${jobId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, 
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete job");
        }
        return response.json();
      })
      .then(() => {
   
        setJobList((prevJobList) => prevJobList.filter((job) => job._id !== jobId));
        console.log("Job deleted successfully");
      })
      .catch((error) => {
        console.error("Error deleting job:", error);
        alert("Failed to delete job. Please try again.");
      });
  };
  

  return (
    <JobContext.Provider
      value={{ jobList, selectedJob, fetchJobList, editJob, deleteJob }}
    >
      {children}
    </JobContext.Provider>
  );
};


export const useJobContext = () => {
  return useContext(JobContext);
};
